import { getImprimir } from "../../services/public/impresion";

export const print = async (impresora, data) => {
    var Fecha = FechaTexto(data.FechaIng);
    
    const Config ={
                    "table":[
                        ["Impresora",1,200],
                        ["MargenX",3,0],
                        ["MargenY",3,0],
                        ["Espaciado",3,0],
                        ["FontName",1,30],
                        ["PiePagina",1,2],
                        ["TextPie",1,200],
                        ["Cortar",1,2]
                    ],
                    "data":[
                            [impresora,4,4,5,"Verdana","S","Desarrollado por Dkd Ingenierias.","N"]
                        ]
    }
    const Ticket = {"table":[
        ["Tipo",1,4],
        ["Align",1,4],
        ["FontSize",3,0],
        ["Texto",1,120],
        ["Bold",1,4]
    ],
    "data":[
        ["T","C",0,data.NombreTerc,"N"],
        ["T","C",0,data.NumeroNit+"-"+data.Chequeo,"NO"],
        ["T","C",0,data.Direccion,"N"],
        ["T","C",0,data.NombreArea,"N"],
        ["T","C",35,data.Prefijo,"S"],
        ["T","C",35,data.Consecutivo,"S"],
        ["T","C",0,data.NombreServ,"N"],
        ["T","C",0, Fecha,"N"],
    ]
    }
  const response = await getImprimir(Config, Ticket);  
  if ((response) && (response.statusText ==="OK"))
  {

  }
  else{

  }
}    

const FechaTexto = (Fecha) =>{
   
     return Fecha.toLocaleString('en-US', { hour12: false });
}
 